export default "__VITE_ASSET__BmPBP8bi__"